if (!customElements.get('product-form-component')) {
  customElements.define(
    'product-form-component',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.form = this.querySelector('form');
        if (!this.form) return;

        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.form?.querySelector('.add-to-cart-button');
        this.submitButtonText = this.submitButton
          ? this.submitButton.querySelector('span')
          : null;
        this.checkbox = this.form?.querySelector('[id^="agree_condition-"]');
        this.buyItNowButton = this.form?.querySelector('.shopify-payment-button');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.initAgreeCondition();
        this.setupErrorSync();
      }

      setupErrorSync() {
        try {
          const productInfo = this.closest('product-info');
          const sectionId =
            productInfo?.dataset.section ||
            productInfo?.dataset.originalSection;

          if (!sectionId) return;

          const stickyATC = document.querySelector(
            `sticky-atc[data-sticky-section-id="${sectionId}"]`
          );
          if (!stickyATC) return;

          const mainErrorWrapper = this.querySelector(
            '.product-form__error-message-wrapper'
          );
          const stickyErrorWrapper = stickyATC.querySelector(
            '.product-form__error-message-wrapper'
          );

          if (!mainErrorWrapper || !stickyErrorWrapper) return;

          const syncFromMain = () => {
            const isVisible = !mainErrorWrapper.hasAttribute('hidden');
            const errorMessage = mainErrorWrapper.querySelector(
              '.product-form__error-message'
            )?.textContent;

            stickyErrorWrapper.toggleAttribute(
              'hidden',
              !isVisible || !errorMessage
            );

            if (isVisible && errorMessage) {
              const stickyErrorMessage = stickyErrorWrapper.querySelector(
                '.product-form__error-message'
              );
              if (stickyErrorMessage) {
                stickyErrorMessage.textContent = errorMessage;
              }
            }
          };

          syncFromMain();

          this._errorObserver = new MutationObserver(syncFromMain);
          this._errorObserver.observe(mainErrorWrapper, {
            attributes: true,
            attributeFilter: ['hidden'],
            childList: true,
            subtree: true,
          });

          this.cartErrorUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartError,
            () => syncFromMain()
          );
        } catch (e) {
          // Keep the product form working if optional error syncing fails.
        }
      }

      initAgreeCondition() {
        if (!this.checkbox || !this.buyItNowButton) return;

        this.buyItNowButton.classList.add('disabled');

        this.checkbox.addEventListener('change', () => {
          this.buyItNowButton.classList.toggle(
            'disabled',
            !this.checkbox.checked
          );
        });

        this.form.addEventListener('submit', (e) => {
          if (!this.checkbox.checked) {
            e.preventDefault();
          }
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          !this.submitButton ||
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        this.submitButton
          .querySelector('.loading__spinner')
          ?.classList.remove('hidden');

        const productInfo = this.closest('product-info');
        const sectionId =
          productInfo?.dataset.section ||
          productInfo?.dataset.originalSection;

        const stickyAddButton = sectionId
          ? document.getElementById(
              `StickyCart-ProductSubmitButton-${sectionId}`
            )
          : undefined;

        const stickyLoadingSpinner =
          stickyAddButton?.querySelector('.loading__spinner');

        if (stickyAddButton && stickyLoadingSpinner) {
          stickyAddButton.classList.add('loading');
          stickyLoadingSpinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Request cart sections without automatically opening the drawer.
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const properties = document.querySelectorAll(
          '.product-form__input [name^="properties"]'
        );

        properties.forEach((property) => {
          if (property.type === 'file') {
            if (
              !property.files ||
              property.files.length === 0 ||
              !property.files[0]
            ) {
              return;
            }

            formData.append(property.name, property.files[0]);
            return;
          }

          if (property.value == null || property.value === '') return;
          formData.append(property.name, property.value);
        });

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form-component',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');

              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form-component',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;

            // Close quick-add modal, if applicable.
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              quickAddModal.hide(true);
            }

            // Refresh cart drawer in the background.
            // This does NOT open the drawer.
            if (
              this.cart &&
              typeof this.cart.renderContents === 'function'
            ) {
              const sectionsUrl = new URL(window.location.href);
              sectionsUrl.search = '';
              sectionsUrl.searchParams.set(
                'sections',
                'cart-drawer,cart-icon-bubble'
              );

              fetch(sectionsUrl.toString(), {
                method: 'GET',
                headers: {
                  'X-Requested-With': 'XMLHttpRequest',
                },
              })
                .then((sectionsResponse) => {
                  if (!sectionsResponse.ok) {
                    throw new Error(
                      `Cart sections request failed: ${sectionsResponse.status}`
                    );
                  }

                  return sectionsResponse.json();
                })
                .then((sections) => {
                  if (!sections || typeof sections !== 'object') {
                    throw new Error(
                      'Shopify returned an invalid cart sections response.'
                    );
                  }

                  return this.cart.renderContents({
                    ...response,
                    sections: sections,
                  });
                })
                .catch((error) => {
                  console.error('Cart drawer refresh failed:', error);
                });
            }

            // Show floating Added to Cart notification.
            this.showFloatingCartNotice(response);
          })
          .catch((e) => {
            console.error('Add to cart failed:', e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            this.submitButton
              .querySelector('.loading__spinner')
              ?.classList.add('hidden');

            const productInfo = this.closest('product-info');
            const sectionId =
              productInfo?.dataset.section ||
              productInfo?.dataset.originalSection;

            const stickyAddButton = sectionId
              ? document.getElementById(
                  `StickyCart-ProductSubmitButton-${sectionId}`
                )
              : undefined;

            const stickyLoadingSpinner =
              stickyAddButton?.querySelector('.loading__spinner');

            if (stickyAddButton && stickyLoadingSpinner) {
              stickyAddButton.classList.remove('loading');
              stickyLoadingSpinner.classList.add('hidden');
            }
          });
      }

      showFloatingCartNotice(response) {
        this.createFloatingCartNotice();

        const notice = document.getElementById('sv-cart-notice');
        const thumb = notice.querySelector('.sv-cart-notice__thumb');
        const plus = notice.querySelector('.sv-cart-notice__plus');
        const text = notice.querySelector('.sv-cart-notice__text');

        const imageValue =
          response.image ||
          response.featured_image?.url ||
          response.featured_image ||
          '';

        let imageUrl = '';

        if (typeof imageValue === 'string') {
          imageUrl = imageValue;
        } else if (imageValue && typeof imageValue === 'object') {
          imageUrl = imageValue.url || '';
        }

        if (imageUrl) {
          thumb.src = imageUrl;
          thumb.style.display = '';
        } else {
          thumb.removeAttribute('src');
          thumb.style.display = 'none';
        }

        plus.textContent = '+1';
        text.textContent = 'Added to cart';

        clearTimeout(window.svCartNoticeTimer);
        notice.classList.add('is-visible');

        // Refresh cart icon bubble and actual cart count.
        const cartUrl = window.routes?.cart_url || '/cart';

        Promise.all([
          fetch(
            `${window.location.pathname}?sections=cart-icon-bubble`
          ).then((res) => (res.ok ? res.json() : {})),

          fetch(`${cartUrl}.js`).then((res) =>
            res.ok ? res.json() : null
          ),
        ])
          .then(([sections, cartData]) => {
            const html = sections['cart-icon-bubble'];

            if (html) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');

              const newBubble = doc.querySelector('#cart-icon-bubble');
              const currentBubble =
                document.querySelector('#cart-icon-bubble');

              if (newBubble && currentBubble) {
                currentBubble.innerHTML = newBubble.innerHTML;
              }
            }

            if (cartData && typeof cartData.item_count === 'number') {
              const count = cartData.item_count;

              text.textContent = `${count} ${
                count === 1 ? 'Item' : 'Items'
              }`;

              plus.textContent = '+1';
            }
          })
          .catch((error) => {
            console.error('Cart notice refresh failed:', error);
          });

        window.svCartNoticeTimer = setTimeout(() => {
          notice.classList.remove('is-visible');
        }, 5000);
      }

      createFloatingCartNotice() {
        if (!document.getElementById('sv-cart-notice-styles')) {
          const style = document.createElement('style');
          style.id = 'sv-cart-notice-styles';

          style.textContent = `
            #sv-cart-notice {
              position: fixed;
              z-index: 999999;
              left: 50%;
              bottom: 24px;
              transform: translate(-50%, 18px);
              width: max-content;
              max-width: calc(100vw - 28px);
              box-sizing: border-box;
              display: flex;
              align-items: center;
              gap: 12px;
              padding: 10px 12px;
              background: #fff;
              color: #252525;
              border: 1px solid rgba(0,0,0,.06);
              border-radius: 999px;
              box-shadow: 0 5px 24px rgba(0,0,0,.16);
              font-family: inherit;
              opacity: 0;
              visibility: hidden;
              transition: opacity .22s ease, transform .22s ease,
                visibility .22s ease;
            }

            #sv-cart-notice.is-visible {
              opacity: 1;
              visibility: visible;
              transform: translate(-50%, 0);
            }

            #sv-cart-notice .sv-cart-notice__thumbs {
              display: flex;
              align-items: center;
              flex-shrink: 0;
              padding-left: 2px;
            }

            #sv-cart-notice .sv-cart-notice__thumb {
              width: 34px;
              height: 34px;
              margin-left: -7px;
              border: 2px solid #fff;
              border-radius: 50%;
              object-fit: cover;
              background: #f4f0e9;
              box-sizing: content-box;
            }

            #sv-cart-notice .sv-cart-notice__thumb:first-child {
              margin-left: 0;
            }

            #sv-cart-notice .sv-cart-notice__plus {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 30px;
              height: 30px;
              margin-left: -7px;
              border: 2px solid #fff;
              border-radius: 50%;
              background: #007810ff;
              color: #fff;
              font-size: 12px;
              font-weight: 700;
              position: relative;
              z-index: 1;
            }

            #sv-cart-notice .sv-cart-notice__text {
              min-width: 0;
              font-size: 14px;
              font-weight: 600;
              white-space: nowrap;
            }

            #sv-cart-notice .sv-cart-notice__button {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              gap: 7px;
              flex-shrink: 0;
              padding: 12px 17px;
              border: 0;
              border-radius: 999px;
              background: #007209ff;
              color: #fff;
              font: inherit;
              font-size: 14px;
              font-weight: 600;
              text-decoration: none;
              cursor: pointer;
            }

            #sv-cart-notice .sv-cart-notice__close {
              position: absolute;
              top: -8px;
              right: -7px;
              width: 25px;
              height: 25px;
              display: flex;
              align-items: center;
              justify-content: center;
              border: 1px solid #e8e8e8;
              border-radius: 50%;
              background: #fff;
              color: #016337ff;
              font-size: 18px;
              line-height: 1;
              cursor: pointer;
              box-shadow: 0 1px 4px rgba(0,0,0,.08);
            }

            @media (max-width: 480px) {
              #sv-cart-notice {
                bottom: 20px;
                gap: 4px;
                padding: 3px 5px;
              }

              #sv-cart-notice .sv-cart-notice__thumb {
                width: 16px;
                height: 16px;
              }

              #sv-cart-notice .sv-cart-notice__plus {
                width: 16px;
                height: 16px;
                font-size: 10px;
              }

              #sv-cart-notice .sv-cart-notice__text {
                font-size: 10px;
              }

              #sv-cart-notice .sv-cart-notice__button {
                padding: 5px 8px;
                font-size: 10px;
                gap: 5px;
              }
            }
          `;

          document.head.appendChild(style);
        }

        let notice = document.getElementById('sv-cart-notice');

        if (!notice) {
          notice = document.createElement('div');
          notice.id = 'sv-cart-notice';
          notice.setAttribute('role', 'status');
          notice.setAttribute('aria-live', 'polite');

          notice.innerHTML = `
            <div class="sv-cart-notice__thumbs">
              <img class="sv-cart-notice__thumb" alt="" />
              <span class="sv-cart-notice__plus">+1</span>
            </div>

            <span class="sv-cart-notice__text">Added to cart</span>

            <button class="sv-cart-notice__button" type="button">
              <svg width="17" height="17" viewBox="0 0 24 24"
                fill="none" aria-hidden="true">
                <path d="M3 4h2l2.2 10.1a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 1.9-1.4L21 8H6"
                  stroke="currentColor" stroke-width="1.7"
                  stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="10" cy="20" r="1.3" fill="currentColor"/>
                <circle cx="18" cy="20" r="1.3" fill="currentColor"/>
              </svg>
            </button>

            <button class="sv-cart-notice__close" type="button"
              aria-label="Close notification">×</button>
          `;

          document.body.appendChild(notice);

         notice
  .querySelector('.sv-cart-notice__button')
  .addEventListener('click', (event) => {
    notice.classList.remove('is-visible');
    clearTimeout(window.svCartNoticeTimer);

    const cartUrl = window.routes?.cart_url || '/cart';

    const goToCart = () => {
      window.location.assign(cartUrl);
    };

    const cartDrawer = document.querySelector('cart-drawer');

    // Direct cart-page fallback if drawer or animation is unavailable.
    if (
      !cartDrawer ||
      !cartDrawer.isConnected ||
      typeof cartDrawer.open !== 'function' ||
      !cartDrawer.querySelector('[data-drawer-content]') ||
      typeof Motion === 'undefined' ||
      typeof Motion.timeline !== 'function'
    ) {
      goToCart();
      return;
    }

    try {
      const opening = cartDrawer.open(event.currentTarget);

      if (opening && typeof opening.catch === 'function') {
        opening.catch((error) => {
          console.error('Floating cart drawer failed:', error);
          goToCart();
        });
      } else if (!cartDrawer.classList.contains('open')) {
        goToCart();
      }
    } catch (error) {
      console.error('Floating cart drawer failed:', error);
      goToCart();
    }
  });

          notice
            .querySelector('.sv-cart-notice__close')
            .addEventListener('click', () => {
              notice.classList.remove('is-visible');
              clearTimeout(window.svCartNoticeTimer);
            });
        }
      }

      disconnectedCallback() {
        try {
          this.cartErrorUnsubscriber?.();
          this._errorObserver?.disconnect();
        } catch (e) {
          // Ignore cleanup errors.
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) {
            this.submitButtonText.textContent =
              window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}